import { IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';

export default withStyles(IconButton, theme => ({
  root: {
    marginLeft: theme.spacing(1),
  },
}), { withTheme: true });
